export default {
	section_banner: {
		main_title: {
			one: 'Currency',
			two: 'Exchange',
		},
		sub_title: {
			one: 'Like A',
			two: 'Bank',
		},
		paragraph: {
			one: 'Selling and buying—are you still going back and forth exchanging money? With JPWorldPay, you can simplify the process and eliminate the hassle.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	exchng_wallet: {
		title: 'JPWorldPay Wallet',
		sub_title: {
			one: 'Exchange & Send Money',
			two: 'Immediately',
		},
		paragraph: {
			one: 'Still having trouble buying and sending crypto assets? With JPWorldPay, you can use it just like a bank. Send and withdraw money instantly, making your<br /> crypto transactions as simple and convenient as traditional banking.',
		},
	},

	question_sec: {
		title: 'With Just One Click Of A Button',
		sub_title: {
			one: 'Exchange Your Money',
			two: 'Easily',
		},
		paragraph:
			'Automatic exchange rate, automatic sales, easy interface-JPWorldPay makes trading simple and efficient. With real-time rate updates and an intuitive design, users can buy or sell assets quickly without confusion. Enjoy a seamless experience that saves time and enhances convenience.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	online_mid: {
		label: 'Crypto Assets & JPWorldPay Points',
		title: {
			one: 'Any',
			two: 'Asset',
			three: 'You Want & At Any Time',
		},
		paragraph:
			'Exchange between crypto assets and JPWorldPay points is simple and flexible. Whether you are onverting one cryptocurrency to another or turning digital assets into JPWorldPay points, the process is smooth and efficient. Enjoy seamless conversions that give you more freedom and control over your finances.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
